const NS = 'DashboardNotificationItemWidget';
const CLS = 'dashboardNotificationItemWidget';

export class DashboardNotificationItemWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		let closeBtn = this.$element.find(`.${CLS}-close`);
		this.id = this.$element.data('id');
		this.notificationReadApi = this.$element.data('notificationReadApi');

		closeBtn.on('click', () => {
			this.$element.fadeOut(400, () => {
				$.ajax({
					type: 'POST',
					url: `${this.notificationReadApi}/${this.id}`,
					dataType: 'json',
					success: () => {
						this.$element.remove();
					}
				});
			});
		});
	}
}
